{
  "aiGeneratedAnswer": "AI wygenerowało odpowiedź",
  "allCategories": "Wszystkie kategorie",
  "appliedFiltersToCurrentSearch": "Zastosowane filtry do bieżącego wyszukiwania",
  "apply": "Zastosuj",
  "applyFilters": "Zastosuj filtry",
  "autocompleteOptionsFound_few": "Znaleziono {{count}}{{label}} opcje autouzupełniania.",
  "autocompleteOptionsFound_one": "Znaleziono {{count}}{{label}} opcję autouzupełniania.",
  "autocompleteOptionsFound_other": "Znaleziono {{count}}{{label}} opcji autouzupełniania.",
  "autocompleteSuggestion": "sugestia autouzupełniania: {{suggestion}}",
  "autocompleteSuggestionsFound_few": "Znaleziono {{count}} sugestie autouzupełniania.",
  "autocompleteSuggestionsFound_one": "Znaleziono {{count}} sugestię autouzupełniania.",
  "autocompleteSuggestionsFound_other": "Znaleziono {{count}} sugestii autouzupełniania.",
  "basedOnYourDevice": " (na podstawie Twojego urządzenia)",
  "basedOnYourInternetAddress": " (na podstawie Twojego adresu internetowego)",
  "categoriesText_few": "Następujące kategorie zwróciły wyniki dla – <strong>{{query}}</strong>",
  "categoriesText_one": "Następująca kategoria zwróciła wyniki dla – <strong>{{query}}</strong>",
  "categoriesText_other": "Następujących kategorii zwróciło wyniki dla – <strong>{{query}}</strong>",
  "clearAll": "Wyczyść wszystko",
  "clearMinAndMax": "Wyczyść min i max",
  "clearTheRangeToSelectOptions": "Wyczyść zakres, aby wybrać opcje.",
  "clearTheSearchBar": "Wyczyść pasek wyszukiwania",
  "conductASearch": "Przeprowadzić wyszukiwanie",
  "currentLocation": "Aktualna lokalizacja",
  "didYouMean": "Czy chodziło Ci o <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Gdy dostępne są wyniki autouzupełniania, użyj strzałek w górę i w dół, aby przejrzeć, a enter, aby wybrać.",
  "feedback": "Informacja zwrotna",
  "invalidRange": "Nieprawidłowy zasięg",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Przejdź do strony następnych wyników",
  "navigateToThePreviousResultsPage": "Przejdź do strony poprzednich wyników",
  "noAutocompleteOptionsFound": "Znaleziono 0 opcji autouzupełniania.",
  "noAutocompleteSuggestionsFound": "Znaleziono 0 sugestii autouzupełniania.",
  "noResultsFoundIn": "Nie znaleziono wyników w {{currentVerticalLabel}}.",
  "pagination": "Paginacja",
  "readMoreAbout": "Czytaj więcej o <a>{{name}}</a>",
  "recentSearch": "najnowsze wyszukiwanie: {{query}}",
  "recentSearchesFound_few": "Znaleziono {{count}} ostatnie wyszukiwania.",
  "recentSearchesFound_one": "Znaleziono {{count}} ostatnie wyszukiwanie.",
  "recentSearchesFound_other": "Znaleziono {{count}} ostatnich wyszukiwań.",
  "removeFilter": "Usuń filtr „{{displayName}}“",
  "resultPreview": "podgląd wyników: {{value}}",
  "resultPreviewsFound_few": "Znaleziono {{count}} podglądy wyników.",
  "resultPreviewsFound_one": "Znaleziono {{count}} podgląd wyniku.",
  "resultPreviewsFound_other": "Znaleziono {{count}} podglądów wyników.",
  "resultsCountText_few": "{{count}} wyniki",
  "resultsCountText_one": "{{count}} wynik",
  "resultsCountText_other": "{{count}} wyników",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} z {{resultsCount}} wyników",
  "searchHere": "Wyszukaj tutaj…",
  "showLess": "Pokaż mniej",
  "showMore": "Pokaż więcej",
  "showingAllInstead": "Wyświetlam wszystkie {{currentVerticalLabel}} zamiast tego.",
  "sources_few": "Źródła ({{count}})",
  "sources_one": "Źródło",
  "sources_other": "Źródeł ({{count}})",
  "submitSearch": "Prześlij wyszukiwanie",
  "suggestionResultsCount_few": "{{label}} – {{count}} wyniki",
  "suggestionResultsCount_one": "{{label}} – {{count}} wynik",
  "suggestionResultsCount_other": "{{label}} – {{count}} wyników",
  "thankYouForYourFeedback": "Dziękujemy za Twoją opinię!",
  "thisAnsweredMyQuestion": "To odpowiedziało na moje pytanie",
  "thisDidNotAnswerMyQuestion": "To nie odpowiedziało na moje pytanie",
  "unselectAnOptionToEnterInARange": "Odznacz opcję, aby wpisać zakres.",
  "updateYourLocation": "Zaktualizuj swoją lokalizację",
  "useCurrentLocation": "Użyj aktualnej lokalizacji",
  "useMyLocation": "Użyj mojej lokalizacji",
  "viewAll": "Zobacz wszystkie",
  "viewDetails": "Zobacz szczegóły"
}
